import React from 'react';
import LoginForm from '../../components/LoginForm';
import Main from '../../components/Main';

// Sign in Subpage of MyAccount Page

const SignIn = () => {
  return (
    <div>
      <Main componentList={[<LoginForm />]} />
    </div>
  );
};

export default SignIn;